import { t } from 'ttag';

import { dayDiscount } from '@urls';
import Grid from '@components/Grid';
import { ClerkActionType, ClerkCategoryType, ClerkProductClickEvent, useClerk } from '@hook/useClerk';
import { ProductCard, Product } from '@components/ProductCard';
import { Button } from '@ui/Button';

import s from './ConversionsCollections.sss';

type ConversionsCollectionsProps = {
  products: Product[];
  href: string;
} & ({ isDynamicCollection: true, slug: string } | { isDynamicCollection?: false, slug?: string });

export const ConversionsCollections: React.FC<ConversionsCollectionsProps> = ({
  products,
  href,
  isDynamicCollection,
  slug,
}) => {
  const { sendClerkEvent } = useClerk();

  const handleProductClick = (productId: number, index: number) => {
    sendClerkEvent<ClerkProductClickEvent>({
      category: ClerkCategoryType.goToDetail,
      action: ClerkActionType.click,
      payload: {
        itemCount: index + 1,
        productId,
        source: slug === dayDiscount ? 'personalDiscount' : 'personalNewArrivals',
      }
    });
  };

  return (
    <div className={s.root}>
      <Grid container={true} spacing={10} className={s.grid}>
        {
          products.map((product, k) => (
            <Grid
              key={product.id}
              desktop="2_4"
              tablet={4}
              def={6}
            >
              <ProductCard
                {...product}
                onProductClick={
                  isDynamicCollection && slug
                    ? () => handleProductClick(product.id, k)
                    : undefined
                }
              />
            </Grid>
          ))
        }
      </Grid>
      <Button
        theme="secondary"
        className={s.button}
        href={href}
      >
        {t`Дивитись усе`}
      </Button>
    </div>
  );
};
